import { PureComponent } from 'preact-compat'

import { ContentType } from '@insided/shared/utils/contentType'

/* eslint-disable import/no-internal-modules */
import Icon from '@insided/deprecated-preact-components/assets'

export interface TopicTitleProps {
  title: string
  contentType: ContentType
  publicId: string
  destinationUrl: string
}

class TopicTitle extends PureComponent<TopicTitleProps> {
  render() {
    const { title, destinationUrl } = this.props
    return (
      <div className='topic-moderation--topic-info__title'>
        <h3>
          {title}{' '}
          <a href={destinationUrl} target='_blank' rel='noreferrer'>
            <Icon icon='externalLink' width={16} height={16} />
          </a>
        </h3>
      </div>
    )
  }
}

export default TopicTitle
